/**
 * Gets the value of a query string param by name either from the given queryString parameter
 * or from the browser's URL.
 */
const getQueryStringParam = (name, queryString = '') => {
  let half;
  const secondHalf = 1;
  if (queryString.length > 0) {
    half = queryString.split(`${name}=`)[secondHalf];
  } else {
    half = window.location.search.split(`${name}=`)[secondHalf];
  }
  return half !== undefined ? decodeURIComponent(half.split('&')[0]) : null;
};

/**
 * Gets the rest of the query value starting from specific param name or from given query string
 * Needed if we want to target the user to specific survey because survey has params e.g. ?target=https://community-dev.puheet.info/survey/index.php?r=survey/index&sid=122417&lang=en
 */
const getQueryStringStartFromParam = (name, queryString = '') => {
  let half;
  const secondHalf = 1;
  if (queryString.length > 0) {
    half = queryString.split(`${name}=`)[secondHalf];
  } else {
    half = window.location.search.split(`${name}=`)[secondHalf];
  }
  return half !== undefined ? decodeURIComponent(half) : null;
};

export default {
  getQueryStringParam,
  getQueryStringStartFromParam,
};
